import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { ProductsService } from '@brafton/atlas-api-client';
import { ProductClass } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';

@Component({
  selector: 'shared-filter-panel-product-classes',
  templateUrl: './filter-panel-product-classes.component.html',
  styleUrls: ['./filter-panel-product-classes.component.scss'],
  host: { class: 'filter-panel-product-classes' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelProductClassesComponent implements OnInit {
  @Input() productClasses: Filter[] = [];
  @Output() productClassesChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  classes$!: Observable<ProductClass[]>;

  constructor(private productService: ProductsService) {}

  ngOnInit() {
    this.classes$ = this.productService.listClasses(true);
  }

  addProduct(productClassDef: ProductClass) {
    if (!this.productClasses.find((sp) => sp.value === productClassDef.id)) {
      this.productClasses.push({
        value: productClassDef.id,
        displayName: productClassDef.module.name + ' > ' + productClassDef.name,
        type: 'product-class',
      } as Filter);
    }
    this.productClassesChange.emit(this.productClasses);
  }

  removeProduct(productClassDef: ProductClass) {
    const index = this.productClasses.findIndex((sp) => sp.value === productClassDef.id);
    if (index > -1) {
      this.productClasses.splice(index, 1);
    }
    this.productClassesChange.emit(this.productClasses);
  }

  clear() {
    this.productClasses = [];
    this.productClassesChange.emit(this.productClasses);
  }

  isSelected(productClassDef: ProductClass): boolean {
    if (!this.productClasses) return false;
    if (this.productClasses.find((sp) => sp.value === productClassDef.id)) return true;
    else return false;
  }
}
